let routes = [
  {
    path: '/modification-carte-affaire',
    component: () => import('../views/ModificationCarteAffaire.vue'),
  }
]

export default routes;